/* eslint-disable react-hooks/exhaustive-deps */
import { CloseOutlined, EyeOutlined, StarFilled } from '@ant-design/icons';
import { Button } from 'antd';
import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { typesConfigs } from '../../../../constants/types';

const Sider = ({
  activeNode,
  activeSources,
  t,
  clear,
  featuredData,
  supplyChainActors,
  informationSources,
  getRedirectLink = () => { },
}) => {
  const headerConfig = useMemo(() =>
    typesConfigs.find((c) => c.type === activeNode.type), [activeNode]);

  const { sources } = useMemo(() => {
    const sources = [];

    const addSources = (s, sources) => {
      if (featuredData) {
        featuredData.forEach((f) => {
          if (activeSources.includes(f.id) && sources.includes(f.id)) {
            s.push({ ...f, type: 'FD' });
          }
        });
      }

      if (supplyChainActors) {
        supplyChainActors.forEach((f) => {
          if (activeSources.includes(f.id) && sources.includes(f.id)) {
            s.push({ ...f, type: 'SCA' });
          }
        });
      }

      if (informationSources) {
        informationSources.forEach((f) => {
          if (activeSources.includes(f.id) && sources.includes(f.id)) {
            s.push({ ...f, type: 'IS' });
          }
        });
      }
    };

    if (activeNode.sources) {
      addSources(sources, activeNode.sources);
    }

    return { sources };
  }, [activeSources, featuredData, supplyChainActors, informationSources, activeNode]);

  const viewAssesmentLink = useMemo(() => {
    if (activeNode.namespace === 'scp') {
      return getRedirectLink(null, activeNode.datastakeId);
    }
    return null;
  }, [activeNode]);

  const renderSources = (all) => {
    return (
      <>
        <label className="section-label">{t('Other Sources')}</label>
        <div className="sources default-content">
          {all.map((s) => (
            <div className="source" key={`sources-${s.id}`}>
              <div className="left">
                {s.type === 'FD' && (
                  <div className="default-content">
                    <StarFilled />
                  </div>
                )}
                {s.type === 'SCA' && (
                  <div className="default-content">
                    <div className="legend sca" />
                  </div>
                )}
                {s.type === 'IS' && (
                  <div className="default-content">
                    <div className="legend is" />
                  </div>
                )}
                <div className="default-content">
                  <label>{s.label}</label>
                </div>
              </div>
              <div className="right">
                <Link
                  to={getRedirectLink(
                    s.id,
                    activeNode.namespace === 'scp' ? activeNode.datastakeId : null,
                    activeNode.namespace === 'scl' ? `/view/scl/${activeNode.datastakeId}/location` : null
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Button icon={<EyeOutlined />} />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  };

  if (headerConfig) {
    return (
      <div className="sider">
        <div className="sider-header">
          <label>{t('Details')}</label>
          <CloseOutlined
            onClick={clear}
            className="trade-relationships-filter"
          />
        </div>
        <div className="body default-content">
          <label className="title" style={{ color: headerConfig.color }}>{activeNode.title}</label>
          <label className="label">{activeNode.label}</label>
          {viewAssesmentLink !== null && (
            <Link
              to={viewAssesmentLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button type="primary" className="view-assessment">
                {t('View Assessment')}
              </Button>
            </Link>
          )}
          {sources.length > 0 && renderSources(sources)}
        </div>
      </div>
    );
  }
  return null;
}

export default Sider;
